(function () {
    const root = document.querySelector('[data-about-carousel]');
    if (!root) {
        return;
    }

    const viewport = root.querySelector('[data-about-carousel-viewport]');
    const prevButton = root.querySelector('[data-about-carousel-prev]');
    const nextButton = root.querySelector('[data-about-carousel-next]');
    const dots = root.querySelector('[data-about-carousel-dots]');
    const slides = Array.from(root.querySelectorAll('[data-about-carousel-slide]'));

    if (!viewport || !prevButton || !nextButton || !dots || slides.length === 0) {
        return;
    }

    let activeIndex = 0;
    let scrollTimer = null;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function findNearestIndex() {
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        slides.forEach(function (slide, index) {
            const distance = Math.abs(slide.offsetLeft - viewport.scrollLeft);
            if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestIndex = index;
            }
        });

        return nearestIndex;
    }

    function scrollToSlide(index, behavior) {
        viewport.scrollTo({
            left: slides[index].offsetLeft,
            behavior: reduceMotion.matches ? 'auto' : (behavior || 'smooth')
        });
    }

    function render(index) {
        activeIndex = index;

        slides.forEach(function (slide, slideIndex) {
            const isActive = slideIndex === activeIndex;
            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        Array.from(dots.children).forEach(function (dot, dotIndex) {
            const isActive = dotIndex === activeIndex;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        prevButton.disabled = activeIndex === 0;
        nextButton.disabled = activeIndex === slides.length - 1;
    }

    slides.forEach(function (_, index) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ai-about-carousel-dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        dot.addEventListener('click', function () {
            render(index);
            scrollToSlide(index);
        });
        dots.appendChild(dot);
    });

    prevButton.addEventListener('click', function () {
        if (activeIndex === 0) {
            return;
        }

        render(activeIndex - 1);
        scrollToSlide(activeIndex);
    });

    nextButton.addEventListener('click', function () {
        if (activeIndex === slides.length - 1) {
            return;
        }

        render(activeIndex + 1);
        scrollToSlide(activeIndex);
    });

    viewport.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
            render(findNearestIndex());
        }, 90);
    }, {passive: true});

    viewport.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft' && activeIndex > 0) {
            event.preventDefault();
            render(activeIndex - 1);
            scrollToSlide(activeIndex);
        }

        if (event.key === 'ArrowRight' && activeIndex < slides.length - 1) {
            event.preventDefault();
            render(activeIndex + 1);
            scrollToSlide(activeIndex);
        }
    });

    window.addEventListener('resize', function () {
        scrollToSlide(activeIndex, 'auto');
    });

    render(0);
    scrollToSlide(0, 'auto');
})();
